(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-main-blog"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-main-blog')) {
		class LTAMainBlog extends HTMLElement {
			connectedCallback() {
				this._cacheElements()
				this._initCache()
				this._addEventListeners()
			}

			disconnectedCallback() {
				if (this.searchInputEl && this._debouncedSearchInput) {
					this.searchInputEl.removeEventListener('input', this._debouncedSearchInput)
				}
			}

			_cacheElements() {
				this.searchInputEl = this.querySelector('[data-search-input]')
				this.searchButtonEl = this.querySelector('[data-search-button]')
				this.gridEl = this.querySelector('[data-grid]')
			}

			_initCache() {
				this.cachedResults = {}
				this._searchRequestId = 0
				if (this.gridEl) {
					this.initialGridHTML = this.gridEl.innerHTML
				}
			}

			_addEventListeners() {
				if (!this.searchInputEl) return

				this._debouncedSearchInput = l_debounce(this.handleSearchInput.bind(this), 300)
				this.searchInputEl.addEventListener('input', this._debouncedSearchInput)
			}

			handleSearchInput() {
				const searchTerm = this._normalizeSearchTerm(this.searchInputEl.value)

				if (!searchTerm) {
					this._searchRequestId++
					this._restoreGrid()
					this._setLoading(false)
					return
				}

				this._setLoading(true)

				if (this.cachedResults[searchTerm]) {
					this._renderSearchResults(this.cachedResults[searchTerm])
					return
				}

				this._fetchSearchResults(searchTerm)
			}

			_normalizeSearchTerm(term) {
				if (!term) return ''
				return term.trim().replace(/ /g, '-').toLowerCase()
			}

			_fetchSearchResults(searchTerm) {
				const requestId = ++this._searchRequestId
				const q = this.searchInputEl.value.trim()
				const baseURL = window.routes.predictive_search_url
				const params = `?q=${encodeURIComponent(q)}&resources[type]=article&section_id=a-ajax-predictive-search-articles`
				const searchURL = `${baseURL}${params}`

				fetch(searchURL)
					.then((response) => response.text())
					.then((htmlText) => {
						if (requestId !== this._searchRequestId) return

						const resultsMarkup = l_getSectionDOM(htmlText, '#shopify-section-a-ajax-predictive-search-articles')
						this.cachedResults[searchTerm] = resultsMarkup
						l_debounce(() => {
							if (requestId !== this._searchRequestId) return
							this._renderSearchResults(resultsMarkup)
						}, 100)()
					})
					.catch(console.error)
					.finally(() => this._setLoading(false))
			}

			_renderSearchResults(resultsMarkup) {
				if (!this.gridEl) return

				if (!resultsMarkup) {
					this.gridEl.innerHTML = ''
					this._setLoading(false)
					return
				}

				const cards = resultsMarkup.querySelectorAll('.l-blog__card')
				this.gridEl.innerHTML = ''
				cards.forEach((card) => {
					this.gridEl.appendChild(card.cloneNode(true))
				})

				this._setLoading(false)
			}

			_restoreGrid() {
				if (this.gridEl && this.initialGridHTML != null) {
					this.gridEl.innerHTML = this.initialGridHTML
				}
			}

			_setLoading(isLoading) {
				if (this.searchButtonEl) {
					this.searchButtonEl.classList.toggle('l-button-loading', isLoading)
				}
			}
		}

		customElements.define('l-main-blog', LTAMainBlog)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-main-blog')) {
		class LTAMainBlog extends HTMLElement {
			connectedCallback() {
				this._cacheElements()
				this._initCache()
				this._addEventListeners()
			}

			disconnectedCallback() {
				if (this.searchInputEl && this._debouncedSearchInput) {
					this.searchInputEl.removeEventListener('input', this._debouncedSearchInput)
				}
			}

			_cacheElements() {
				this.searchInputEl = this.querySelector('[data-search-input]')
				this.searchButtonEl = this.querySelector('[data-search-button]')
				this.gridEl = this.querySelector('[data-grid]')
			}

			_initCache() {
				this.cachedResults = {}
				this._searchRequestId = 0
				if (this.gridEl) {
					this.initialGridHTML = this.gridEl.innerHTML
				}
			}

			_addEventListeners() {
				if (!this.searchInputEl) return

				this._debouncedSearchInput = l_debounce(this.handleSearchInput.bind(this), 300)
				this.searchInputEl.addEventListener('input', this._debouncedSearchInput)
			}

			handleSearchInput() {
				const searchTerm = this._normalizeSearchTerm(this.searchInputEl.value)

				if (!searchTerm) {
					this._searchRequestId++
					this._restoreGrid()
					this._setLoading(false)
					return
				}

				this._setLoading(true)

				if (this.cachedResults[searchTerm]) {
					this._renderSearchResults(this.cachedResults[searchTerm])
					return
				}

				this._fetchSearchResults(searchTerm)
			}

			_normalizeSearchTerm(term) {
				if (!term) return ''
				return term.trim().replace(/ /g, '-').toLowerCase()
			}

			_fetchSearchResults(searchTerm) {
				const requestId = ++this._searchRequestId
				const q = this.searchInputEl.value.trim()
				const baseURL = window.routes.predictive_search_url
				const params = `?q=${encodeURIComponent(q)}&resources[type]=article&section_id=a-ajax-predictive-search-articles`
				const searchURL = `${baseURL}${params}`

				fetch(searchURL)
					.then((response) => response.text())
					.then((htmlText) => {
						if (requestId !== this._searchRequestId) return

						const resultsMarkup = l_getSectionDOM(htmlText, '#shopify-section-a-ajax-predictive-search-articles')
						this.cachedResults[searchTerm] = resultsMarkup
						l_debounce(() => {
							if (requestId !== this._searchRequestId) return
							this._renderSearchResults(resultsMarkup)
						}, 100)()
					})
					.catch(console.error)
					.finally(() => this._setLoading(false))
			}

			_renderSearchResults(resultsMarkup) {
				if (!this.gridEl) return

				if (!resultsMarkup) {
					this.gridEl.innerHTML = ''
					this._setLoading(false)
					return
				}

				const cards = resultsMarkup.querySelectorAll('.l-blog__card')
				this.gridEl.innerHTML = ''
				cards.forEach((card) => {
					this.gridEl.appendChild(card.cloneNode(true))
				})

				this._setLoading(false)
			}

			_restoreGrid() {
				if (this.gridEl && this.initialGridHTML != null) {
					this.gridEl.innerHTML = this.initialGridHTML
				}
			}

			_setLoading(isLoading) {
				if (this.searchButtonEl) {
					this.searchButtonEl.classList.toggle('l-button-loading', isLoading)
				}
			}
		}

		customElements.define('l-main-blog', LTAMainBlog)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
